//
// Main Menu, submenu toggle
//

//== Submenu Toggle
//
const submenuToggle = document.querySelectorAll('.navSubmenu-toggle');

submenuToggle.forEach(function (el) {
    el.addEventListener("click", function () {
        toggleSubmenu(el);
    });
    el.addEventListener("keypress", function () {
        toggleSubmenu(el);
    });
});

function toggleSubmenu(el) {
    el.parentElement.classList.add('submenu--open');
    el.parentElement.parentElement.classList.add('submenu--visible');
}

//== Submenu Toggle
//
const parentBackLink = document.querySelectorAll('.back-to-parent-toggle');

parentBackLink.forEach(function (el) {
    el.addEventListener("click", function () {
        toggleParent(el);
    });
    el.addEventListener("keypress", function () {
        toggleParent(el);
    });
});

function toggleParent(el) {
    el.parentElement.parentElement.parentElement.classList.remove('submenu--open');
    el.parentElement.parentElement.parentElement.parentElement.classList.remove('submenu--visible');
}

export default {};
